document.addEventListener("DOMContentLoaded", function () {
  const headerBurger = document.querySelector(".header__burger");
  const headerMenu = document.querySelector(".burger-menu");
  const burgerOverlay = document.querySelector(".burger-menu__overlay");

  if (headerBurger) {
    headerBurger.addEventListener("click", function () {
      if (headerMenu) {
        headerMenu.classList.toggle("burger-menu--active");
      }
    });

    if (burgerOverlay) {
      burgerOverlay.addEventListener("click", function () {
        if (headerMenu) {
          headerMenu.classList.remove("burger-menu--active");
        }
      });
    }
  }

  // Country disclosure search functionality
  const disclosureSearchInput = document.querySelector(".disclosure__search-input");
  if (disclosureSearchInput) {
    disclosureSearchInput.addEventListener("input", function (e) {
      const searchTerm = e.target.value.toLowerCase();
      const items = document.querySelectorAll(".disclosure__item");

      items.forEach(function (item) {
        const countryName = item.getAttribute("data-country-name");
        if (countryName && countryName.includes(searchTerm)) {
          item.removeAttribute("hidden");
        } else {
          item.setAttribute("hidden", "");
        }
      });
    });
  }
});
